module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c(_vm.layout, {
    tag: "component"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-486f770a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 516
// module chunks = 1